import { persistentCache } from "~/utils/asyncDataCache";
import { querySettings } from "~/utils/queries/settings";

/**
 * Per-locale `settings.md` query. Reactive to locale changes — when the
 * passed Ref updates (locale switcher, in-app language change), the
 * underlying `useAsyncData` re-fetches via `watch`, so consumers like the
 * SubNavigationMenu's external links pick up the new locale's settings
 * without needing the component to re-mount.
 *
 * Returns the typed `Settings | null` shape — fields accessible without an
 * `as any` cast at the call site. See `app/utils/queries/settings.ts` for
 * the single boundary cast.
 */
export function useSettings(locale: string | Ref<string>) {
  return useAsyncData(
    () => `settings-${toValue(locale)}`,
    () => querySettings(toValue(locale)),
    {
      watch: isRef(locale) ? [locale] : [],
      ...persistentCache,
    },
  );
}
